<template>
  <a-modal
    :title="title"
    :visible="visible"
    :confirm-loading="submitting"
    @ok="handleSubmit"
    @cancel="$emit('close')"
    width="600px"
  >
    <a-spin :spinning="loading">
      <a-form :form="form">
        <!-- Date -->
        <a-form-item
          label="Date"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-date-picker v-decorator="['date', { initialValue: moment() }]" style="width: 100%" />
        </a-form-item>

        <!-- Status -->
        <a-form-item label="Status" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-select
            v-decorator="[
              'status',
              { rules: [{ required: true, message: 'Please select a status' }] }
            ]"
          >
            <a-select-option value="Not Started">Not Started</a-select-option>
            <a-select-option value="Started">Started</a-select-option>
            <a-select-option value="In Progress">In Progress</a-select-option>
            <a-select-option value="Completed">Completed</a-select-option>
          </a-select>
        </a-form-item>

        <!-- Details -->
        <a-form-item label="Details" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-textarea
            v-decorator="['details']"
            :rows="3"
            placeholder="Enter any additional details"
          />
        </a-form-item>

        <!-- Remarks -->
        <a-form-item label="Remarks" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-textarea
            v-decorator="['remarks']"
            :rows="3"
            placeholder="Enter any remarks"
          />
        </a-form-item>

        <!-- Substitute Checkbox -->
        <a-form-item :wrapper-col="{ span: 16, offset: 6 }">
          <a-checkbox v-decorator="['is_substitute', { valuePropName: 'checked' }]">
            Mark as Substitute Teacher
          </a-checkbox>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'

export default {
  name: 'WizardUpdateProgressModal',
  props: {
    visible: Boolean,
    item: { type: Object, default: () => ({}) }, // Topic or SubTopic to update
    wizardData: { type: Object, default: () => ({}) }, // Contains section_id, period, teacher_id
    existingLog: { type: Object, default: null }, // If editing existing
  },
  data() {
    return {
      form: this.$form.createForm(this),
      submitting: false,
      loading: false,
    }
  },
  computed: {
    title() {
      if (!this.item) return 'Update Progress'
      const typeStr = this.item.type === 'topic' ? 'Topic' : 'Sub-Topic'
      return `Update Progress: ${this.item.name || this.item.topic_name || this.item.sub_topic_name || typeStr}`
    },
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.existingLog) {
          // eslint-disable-next-line camelcase
          const { status, details, remarks, date, is_substitute: isSubstitute } = this.existingLog
          this.$nextTick(() => {
            this.form.setFieldsValue({
              status,
              details,
              remarks,
              // eslint-disable-next-line camelcase
              is_substitute: !!isSubstitute,
              // eslint-disable-next-line camelcase
              date: date ? moment(date) : moment(),
            })
          })
        } else {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              status: this.item.status || 'Not Started',
            })
          })
        }
      } else {
        this.form.resetFields()
      }
    },
  },
  methods: {
    moment,
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const payload = {
            ...values,
            date: values.date ? values.date.format('YYYY-MM-DD') : null,
            section_id: this.wizardData.section_id,
            period: this.wizardData.period,
            teacher_id: this.wizardData.teacher_id,
          }

          if (this.item.type === 'topic') {
            payload.topic_id = this.item.id
          } else if (this.item.type === 'sub-topic') {
            payload.sub_topic_id = this.item.id
          }

          let url = '/api/lesson-plan/teacher/progress'
          let method = 'post'

          if (this.existingLog && this.existingLog.id) {
            url = `/api/lesson-plan/teacher/progress/${this.existingLog.id}`
            method = 'put'
          }

          this.submitting = true
          this.$http[method](url, payload)
            .then(() => {
              this.$notification.success({ message: 'Progress updated successfully' })
              this.$emit('updated')
              this.$emit('close')
            })
            .catch(err => {
              this.$notification.error({ message: 'Failed to update progress' })
              console.error(err)
            })
            .finally(() => {
              this.submitting = false
            })
        }
      })
    },
  },
}
</script>
